/**
 * Just register common components!!!
 */
import Vue from "vue";
import LayoutBase from "@/components/layouts/LayoutBase.vue";

Vue.component("LayoutBase", LayoutBase);
